import clsx from 'clsx'

function Section({
  title,
  children,
  variant = 'violet',
}: {
  title: string | JSX.Element
  children: JSX.Element
  variant?: 'violet' | 'green'
}) {
  return (
    <section>
      <h2
        className={clsx(
          'text-xl font-medium text-white text-center py-8 sm:text-2xl lg:text-5xl',
          variant === 'violet' ? 'bg-[#837ddd]' : 'bg-[#85cfc4]'
        )}
      >
        {title}
      </h2>
      <article className="relative pt-12 box">{children}</article>
    </section>
  )
}

export default Section
